import { render, staticRenderFns } from "./LawLedesCodeTypeList.vue?vue&type=template&id=7974584a&"
import script from "./LawLedesCodeTypeList.vue?vue&type=script&lang=js&"
export * from "./LawLedesCodeTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesCodeTypeList.vue?vue&type=style&index=0&id=7974584a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports